export default __webpack_public_path__ + "static/media/element_77.a14d9a71.webp";